import gql from 'graphql-tag'

export default gql`
  query ListUsers($limit: Int, $nextToken: String, $search: String, $sortBy: UserSortInput) {
    listUsers(limit: $limit, nextToken: $nextToken, search: $search, sortBy: $sortBy) {
      items {
        id
        firstname
        lastname
        email
        company
        organisations {
          id
          name
          projects {
            id
            name
            organisation {
              id
              name
            }
            workflows {
              id
              name
              projectId
              eventsJson {
                id
              }
            }
            teamMembers {
              id
              userId
              lastLogin
              email
            }
          }
        }
        registrationDate
        lastLogin
        loginCounter
        referralSource
        usageIntent
        stripeCustomerId
      }
      nextToken
    }
  }
`
